"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bech32 = exports.coinConvert = void 0;
var decimal_js_1 = require("decimal.js");
decimal_js_1.Decimal.set({ toExpPos: 50 });
function coinConvert(number, decimals, type, fixed) {
    if (!number)
        return '';
    var theNumber = number;
    if (typeof number === 'number') {
        theNumber = number.toString();
    }
    if (theNumber.indexOf('.') === -1) {
        var result = void 0;
        if (type && type === 'machine') {
            result = new decimal_js_1.Decimal(10).toPower(decimals).times(number);
        }
        else {
            result = new decimal_js_1.Decimal(number).dividedBy(new decimal_js_1.Decimal(10).toPower(decimals));
        }
        if (typeof fixed !== 'undefined') {
            return result.toFixed(fixed);
        }
        return result.toString();
    }
    else {
        var result = void 0;
        if (type && type === 'human') {
            result = new decimal_js_1.Decimal(number);
        }
        else {
            result = new decimal_js_1.Decimal(10).toPower(decimals).times(number);
        }
        if (typeof fixed !== 'undefined') {
            return result.toFixed(fixed);
        }
        return result.toString();
    }
}
exports.coinConvert = coinConvert;
function bech32(str, abbrv) {
    if (!str)
        return '';
    var half = abbrv / 2 || 8;
    return (str.substring(0, half) +
        '...' +
        str.substring(str.length - half, str.length));
}
exports.bech32 = bech32;
//# sourceMappingURL=utils.js.map